import React, { useState, useEffect } from 'react';
import Navbar from '../Shared/Navbar';
import api from '../../config/api';
import { Link } from 'react-router-dom';
import '../Creator/Dashboard.css';

function RecruiterDashboard({ user, onLogout }) {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      const response = await api.get('/api/analytics/recruiter');
      setAnalytics(response.data);
    } catch (error) {
      console.error('Failed to fetch analytics:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar user={user} onLogout={onLogout} userType="recruiter" />
        <div className="dashboard-container">
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar user={user} onLogout={onLogout} userType="recruiter" />
      
      <div className="dashboard-container">
        <div className="dashboard-header">
          <div>
            <h1>Recruiter Dashboard</h1>
            <p className="text-gray-600">Track your hiring pipeline and talent discovery</p>
          </div>
          <Link to="/recruiter/search" className="btn btn-primary">
            🔍 Search Talent
          </Link>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#dbeafe' }}>
              🔍
            </div>
            <div>
              <div className="stat-value">{analytics?.overview.activeSearches || 0}</div>
              <div className="stat-label">Active Searches</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#fef3c7' }}>
              👥
            </div>
            <div>
              <div className="stat-value">{analytics?.overview.candidatesInPipeline || 0}</div>
              <div className="stat-label">Candidates in Pipeline</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#d1fae5' }}>
              ⚡
            </div>
            <div>
              <div className="stat-value">{analytics?.overview.timeToShortlist || 0} days</div>
              <div className="stat-label">Time to Shortlist</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#e0e7ff' }}>
              ✅
            </div>
            <div>
              <div className="stat-value">{((analytics?.overview.offerAcceptanceRate || 0) * 100).toFixed(0)}%</div>
              <div className="stat-label">Offer Acceptance Rate</div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions">
          <h2>Quick Actions</h2>
          <div className="action-grid">
            <Link to="/recruiter/search" className="action-card">
              <div className="action-icon">🔍</div>
              <h3>Search Talent</h3>
              <p>Find designers with AI-powered filters</p>
            </Link>

            <Link to="/recruiter/pipeline" className="action-card">
              <div className="action-icon">📊</div>
              <h3>Manage Pipeline</h3>
              <p>Review and move candidates through stages</p>
            </Link>

            <div className="action-card">
              <div className="action-icon">💾</div>
              <h3>Saved Searches</h3>
              <p>Access your frequently used filters</p>
            </div>
          </div>
        </div>

        {/* Pipeline Metrics */}
        {analytics?.pipelineMetrics && (
          <div className="card" style={{ marginTop: '2rem' }}>
            <h2>Pipeline Overview</h2>
            <div className="table-responsive" style={{ marginTop: '1rem' }}>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Stage</th>
                    <th>Candidates</th>
                  </tr>
                </thead>
                <tbody>
                  {analytics.pipelineMetrics.byStage.map((stage, idx) => (
                    <tr key={idx}>
                      <td>{stage.stage}</td>
                      <td><strong>{stage.count}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RecruiterDashboard;
